import * as React from "react";
import { Spin } from "antd";
import { CustomModal } from "../common/CustomModal";
import { EditForm } from "./EditForm";

export class EditModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            data: [],
            recordDetails: {},
            isLoading: false, // Fixme this should be true
            closable: true,
        };
    }

    componentDidMount() {
        if (this.props.refx) {
            this.props.refx(this);
        }
    }

    handleOk = (e) => {
        this.setState({
            visible: false,
        });
    };

    handleCancel = (e) => {
        this.hide();
    };

    show() {
        this.setState({
            visible: true,
        });
    }

    hide() {
        this.setState({
            visible: false,
        }, () => {
            if (this.props.onClose) {
                setTimeout(() => {
                    this.props.onClose();
                }, 300);
            }
        });
    }

    render() {
        return (
            <CustomModal
                width="1000px"
                className="big-modal"
                closable={true}
                visible={this.props.visible}
                title="Edit Course Session Topic"
                onOk={this.props.onClose}
                onCancel={this.props.onClose}
                footer={null}
                destroyOnClose={true}
            >
                {this.state.isLoading ? (
                    <div style={{ justifyContent: "center" }}>
                        <Spin />
                    </div>
                ) : (
                    <EditForm
                        data={this.props.courseSelectedData}
                        onSubmit={this.props.onSubmit}
                        handleCancel={this.handleCancel}
                        course_id={this.props.course_id}
                        authToken={this.props.authToken}
                    />
                )}
            </CustomModal>
        );
    }
}
